import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { styled } from '@mui/system';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { FC } from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { StepIcon } from './StepIcon';
import { TBaseStepper } from './type';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const BaseStepper: FC<TBaseStepper> = ({
  activeStep,
  children,
  steps,
}) => {
  const { t } = useTranslation('payroll');

  return (
    <Box sx={{
      mt: 2,
    }}
    >
      <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={StepIcon}>{t(`${label}`)}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {children}
    </Box>
  );
};

BaseStepper.defaultProps = {
  nextBtnText: 'Next',
} as TBaseStepper;

export {
  BaseStepper,
};
